/*
  Elle Exist — hero slider
  ---------------------------------------------------------------------------
  The track is a scroll-snap rail, so swiping already works with this file
  absent. What is added here is the part a rail cannot do on its own: dots,
  arrows and an autoplay that knows when to stop.

  Autoplay pauses on hover, on keyboard focus, while the tab is in the
  background and while a finger is on the track, and never starts at all for
  a visitor who asked for reduced motion.
*/
(function () {
  'use strict';

  if (customElements.get('ee-hero-slider')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define(
    'ee-hero-slider',
    class EeHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ee-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-ee-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-ee-hero-dot]'));
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.paused = false;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        var prev = this.querySelector('[data-ee-hero-prev]');
        var next = this.querySelector('[data-ee-hero-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
        if (next) next.addEventListener('click', () => this.go(this.index + 1));

        // the rail is the source of truth: a swipe, a click and an autoplay
        // step all end up here
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            var width = this.track.clientWidth;
            if (width) this.setActive(Math.round(this.track.scrollLeft / width));
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.onEnter = () => this.pause();
        this.onLeave = () => this.resume();
        this.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('pointerleave', this.onLeave);
        this.addEventListener('focusin', this.onEnter);
        this.addEventListener('focusout', this.onLeave);
        this.track.addEventListener('pointerdown', this.onEnter);
        this.track.addEventListener('pointerup', this.onLeave);

        this.onVisibility = () => (document.hidden ? this.pause() : this.resume());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.track?.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      get interval() {
        return parseInt(this.dataset.eeAutoplay || '0', 10);
      }

      go(index) {
        var count = this.slides.length;
        var target = ((index % count) + count) % count; // wraps both ways
        var slide = this.slides[target];
        if (!slide) return;
        this.track.scrollTo({
          left: slide.offsetLeft - this.track.offsetLeft,
          behavior: REDUCED.matches ? 'auto' : 'smooth',
        });
        this.setActive(target);
      }

      setActive(index) {
        var current = Math.max(0, Math.min(index, this.slides.length - 1));
        if (current === this.index) return;
        this.index = current;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
      }

      start() {
        if (!this.interval || REDUCED.matches) return;
        this.stop();
        this.timer = setInterval(() => {
          if (!this.paused) this.go(this.index + 1);
        }, this.interval);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.paused = true;
      }

      resume() {
        this.paused = false;
      }
    }
  );
})();
